import React, { Fragment, useEffect, useState } from "react";
import {
  Typography,
  Box,
  Table,
  AspectRatio,
  Divider,
  ButtonGroup,
  Button,
  Sheet,
  Modal,
  ModalOverflow,
  ModalDialog,
  ModalClose,
  DialogTitle,
  DialogContent,
  Stack,
  FormControl,
  FormLabel,
  Input,
  Select,
  Option,
} from "@mui/joy";
import { toast } from "react-toastify";
import { LoadingView, MapContainer, PageTitle } from "../../../components";
import { useLocation, useNavigate } from "react-router-dom";
import { FILE_BASE, STATUS } from "../../../constant";
import { connect, useDispatch } from "react-redux";
import {
  deactivateAgentRequest,
  activateAgentRequest,
  deactivateAgentReset,
  activateAgentReset,
  viewAgentReset,
  viewAgentRequest,
  rejectAgentRequest,
  rejectAgentReset,
  approveAgentRequest,
  approveAgentReset,
  editAgentRequest,
  editAgentReset,
  fetchAgentStaffRequest,
  fetchAgentStaffReset,
  getActivePartnersRequest,
  getWakalaAccountDetailsRequest,
} from "../../../store/actions";
import {
  AddCardOutlined,
  BlockOutlined,
  CheckCircle,
  DoNotDisturbOn,
  EditOutlined,
  FolderOpenOutlined,
  LocationOn,
  RemoveRedEyeOutlined,
  TaskAltOutlined,
} from "@mui/icons-material";
import {
  NAVIGATE_TO_ACCOUNTVIEWPAGE,
  NAVIGATE_TO_AGENTBANKDETAILSPAGE,
  NAVIGATE_TO_AGENTCOMMISSIONSPAGE,
  NAVIGATE_TO_AGENTSTAFFPAGE,
} from "../../../route/types";
import locations from "../../../assets/locations.json";

function CreateItems(title: String, value: String) {
  return { title, value };
}

const AgentViewPage = ({
  loginResult,

  editAgentStatus,
  editAgentResult,
  editAgentErrorMessage,

  viewAgentStatus,
  viewAgentResult,
  viewAgentErrorMessage,

  rejectAgentStatus,
  rejectAgentResult,
  rejectAgentErrorMessage,

  approveAgentStatus,
  approveAgentResult,
  approveAgentErrorMessage,

  activateAgentStatus,
  activateAgentResult,
  activateAgentErrorMessage,

  deactivateAgentStatus,
  deactivateAgentResult,
  deactivateAgentErrorMessage,

  agentStaffListStatus,
  agentStaffListResult,
  agentStaffListErrorMessage,

  getActivePartnersStatus,
  getActivePartnersResult,
  getActivePartnersErrorMessage,

  getWakalaAccountDetailsStatus,
  getWakalaAccountDetailsResult,
  getWakalaAccountDetailsErrorMessage,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { agent_id } = state;

  const [formModal, setFormModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [deactivateModal, setDeactivateModal] = useState(false);

  const [name, setName] = useState("");
  const [ownership, setOwenership] = useState("");
  const [location, setLocation] = useState({
    latitude: 0,
    longitude: 0,
  });
  const [nearest, setNearest] = useState("");
  const [ward, setWard] = useState("");
  const [street, setStreet] = useState("");
  const [other, setOther] = useState("");
  const [post_code, setPostCode] = useState("");
  const [zip_code, setZipCode] = useState("");
  const [status, setStatus] = useState(0);
  const [accountsCount, setAccountsCount] = useState(0);
  const [remark, setRemark] = useState("");
  const [accountCode, setAccountCode] = useState(0);
  const [bankNumber, setBankNumber] = useState("");

  const [regionList, setRegionList] = useState([]);
  const [region, setRegion] = useState("");
  const [districtList, setDistrictList] = useState([]);
  const [district, setDistrict] = useState("");

  const [attachments, setAttachments] = useState([
    {
      attachment_name: "",
      attachment_value: "",
      file: null,
      url: "",
    },
  ]);

  useEffect(() => {
    if (viewAgentStatus === STATUS.SUCCESS) {
      setAccountCode(viewAgentResult.wakalaData.account_code);
      setBankNumber(viewAgentResult.wakalaData.ref_bank_number);
      setName(viewAgentResult.wakalaData.name);
      setDistrict(viewAgentResult.wakalaData.address.district);
      setLocation({
        latitude: viewAgentResult.wakalaData.address.latitude,
        longitude: viewAgentResult.wakalaData.address.longitude,
      });
      setWard(viewAgentResult.wakalaData.address.ward);
      setStreet(viewAgentResult.wakalaData.address.street);
      setRegion(viewAgentResult.wakalaData.address.region);
      setPostCode(viewAgentResult.wakalaData.address.post_code);
      setNearest(viewAgentResult.wakalaData.address.nearest_landmark);
      setStatus(viewAgentResult.wakalaData.status);
      setOther(viewAgentResult.wakalaData.address.other_details);
      setZipCode(viewAgentResult.wakalaData.address.zip_code);
      setOwenership(viewAgentResult.wakalaData.ownership);
      setRemark(viewAgentResult.wakalaData.remark);
      setAccountsCount(viewAgentResult.wakalaAccounts);
      setAttachments(
        viewAgentResult.attachments.map((item, index) => ({
          attachment_name: item.attachment_name,
          attachment_value: item.attachment_value,
          file: null,
          url: FILE_BASE + "/auth/attachments/" + item.file_path,
        })),
      );
      setTimeout(() => {
        dispatch(viewAgentReset());
      }, 2000);
    } else if (viewAgentStatus === STATUS.ERROR) {
      toast.error(viewAgentErrorMessage);
      dispatch(viewAgentReset());
    }

    if (editAgentStatus === STATUS.SUCCESS) {
      toast.success("Agent edited successful");
      setFormModal(false);
      dispatch(viewAgentRequest(loginResult.token, { id: agent_id }));
      dispatch(editAgentReset());
    } else if (editAgentStatus === STATUS.ERROR) {
      toast.error(editAgentErrorMessage);
      dispatch(editAgentReset());
    }

    if (approveAgentStatus === STATUS.SUCCESS) {
      toast.success("Agent approved successful");
      dispatch(viewAgentRequest(loginResult.token, { id: agent_id }));
      dispatch(approveAgentReset());
    } else if (approveAgentStatus === STATUS.ERROR) {
      toast.error(approveAgentErrorMessage);
      dispatch(approveAgentReset());
    }

    if (rejectAgentStatus === STATUS.SUCCESS) {
      toast.success("Agent rejected successful");
      setRejectModal(false);
      dispatch(viewAgentRequest(loginResult.token, { id: agent_id }));
      dispatch(rejectAgentReset());
    } else if (rejectAgentStatus === STATUS.ERROR) {
      toast.error(rejectAgentErrorMessage);
      dispatch(rejectAgentReset());
    }

    if (activateAgentStatus === STATUS.SUCCESS) {
      toast.success("Agent activated successful");
      dispatch(viewAgentRequest(loginResult.token, { id: agent_id }));
    } else if (activateAgentStatus === STATUS.ERROR) {
      toast.error(activateAgentErrorMessage);
      dispatch(activateAgentReset());
    }

    if (deactivateAgentStatus === STATUS.SUCCESS) {
      toast.success("Agent deactivated successful");
      setDeactivateModal(false);
      dispatch(viewAgentRequest(loginResult.token, { id: agent_id }));
      dispatch(deactivateAgentReset());
    } else if (activateAgentStatus === STATUS.ERROR) {
      toast.error(deactivateAgentErrorMessage);
      dispatch(deactivateAgentReset());
    }
  });

  useEffect(() => {
    if (agent_id != "") {
      dispatch(viewAgentRequest(loginResult.token, { id: agent_id }));
      dispatch(fetchAgentStaffRequest(loginResult.token, { id: agent_id }));
    }
  }, []);

  useEffect(() => {
    dispatch(getActivePartnersRequest(loginResult.token, {}));
  }, [loginResult.token, dispatch]);

  useEffect(() => {
    dispatch(
      getWakalaAccountDetailsRequest(loginResult.token, {
        wakala_id: agent_id,
      }),
    );
  }, [loginResult.token, dispatch, agent_id]);

  // get agent user list
  const [agentList, setAgentList] = useState([]);
  useEffect(() => {
    if (agentStaffListStatus === STATUS.SUCCESS) {
      setAgentList(agentStaffListResult);
    } else if (agentStaffListStatus === STATUS.ERROR) {
      setAgentList([]);
      // toast.error(agentStaffListErrorMessage)
      dispatch(fetchAgentStaffReset());
    }
  }, [agentStaffListStatus]);

  /* --------------- location (region and district data) ----------- */

  useEffect(() => {
    let _regions = [];
    locations.map((val) => {
      _regions.push(val.name);
    });
    setRegionList(_regions);
  }, []);

  useEffect(() => {
    //first clear selected district
    // setDistrict('')
    locations.find((location) => {
      //return location.name = region
      let _districtList = [];
      if (location.name == region) {
        location.districts.map((val) => {
          _districtList.push(val.name);
        });
        setDistrictList(_districtList);
        return;
      }
    });
  }, [region]);

  const handleRegion = (event, newValue) => {
    setRegion(newValue);
  };

  const handleDistrict = (event, newValue) => {
    setDistrict(newValue);
  };

  // FUNCTION TO GET LOCATION
  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (error) => {
          console.error("Error getting location:", error.message);
        },
      );
    } else {
      alert(
        "Geolocation is not supported with this browser, please use another browser for completion",
      );
    }
  };

  // FUNCTION TO ADD, REMOVE AND HANDLE COLLATERAL INPUTS
  const addAttachmentsData = () => {
    setAttachments([
      ...attachments,
      {
        attachment_name: "",
        attachment_value: "",
        file: null,
        url: "",
      },
    ]);
  };

  const removeAttachmentsData = (index) => {
    const updateData = [...attachments];
    updateData.splice(index, 1);
    setAttachments(updateData);
  };

  const handleAttachmentsChange = (index, field, text) => {
    const updatedFields = [...attachments];
    updatedFields[index][field] = text;
    setAttachments(updatedFields);
  };

  // FUNCTION TO GET PICTURE
  const handlePicture = (event, index) => {
    console.log("Picture pros: ", event.target.files);
    const updatedFields = [...attachments];
    updatedFields[index]["file"] = event.target.files[0];
    updatedFields[index]["url"] = URL.createObjectURL(event.target.files[0]);
    setAttachments(updatedFields);
  };

  const handleAgentAdd = (event, newValue) => {
    setOwenership(newValue);
  };

  const submitForm = (event) => {
    event.preventDefault();
    if (name && street && ward && ownership && region && district) {
      const formData = new FormData();

      // Append non-file data
      formData.append("id", agent_id);
      formData.append("street", street);
      formData.append("ward", ward);
      formData.append("district", district);
      formData.append("region", region);
      formData.append("zip_code", zip_code);
      formData.append("post_code", post_code);
      formData.append("latitude", location.latitude.toString());
      formData.append("longitude", location.longitude.toString());
      formData.append("nearest_landmark", nearest);
      formData.append("other_details", other);
      formData.append("name", name);
      formData.append("ownership", ownership);
      // attachments.forEach((item, index) => {
      //     formData.append(`attachments[${index}][file]`, item.file);
      //     formData.append(`attachments[${index}][attachment_name]`, item.attachment_name);
      //     formData.append(`attachments[${index}][attachment_value]`, item.attachment_value);
      // });

      dispatch(editAgentRequest(loginResult.token, formData));
    } else {
      toast.error("Please fill all required information");
    }
  };

  // ------ actions -------------------------
  const approveAgent = () => {
    const data = {
      id: agent_id,
    };
    dispatch(approveAgentRequest(loginResult.token, data));
  };

  const rejectAgent = (event) => {
    event.preventDefault();
    const data = {
      id: agent_id,
      remark: remark,
    };
    dispatch(rejectAgentRequest(loginResult.token, data));
  };

  const activateAgent = () => {
    const data = {
      id: agent_id,
    };
    dispatch(activateAgentRequest(loginResult.token, data));
  };

  const deactivateAgent = (event) => {
    event.preventDefault();
    const data = {
      id: agent_id,
      remark: remark,
    };
    dispatch(deactivateAgentRequest(loginResult.token, data));
  };

  const goToAgent = () => {
    navigate(NAVIGATE_TO_AGENTSTAFFPAGE, {
      state: {
        agent_id: agent_id,
      },
    });
  };

  const goToAgentBankDetails = () => {
    navigate(NAVIGATE_TO_AGENTBANKDETAILSPAGE, {
      state: {
        id: agent_id,
      },
    });
  };

  const goToCommissions = () => {
    navigate(NAVIGATE_TO_AGENTCOMMISSIONSPAGE, {
      state: {
        agent_id: agent_id,
      },
    });
  };

  const goToViewPage = (details) => {
    navigate(NAVIGATE_TO_ACCOUNTVIEWPAGE, {
      state: {
        account_code: getWakalaAccountDetailsResult?.accountCode,
        agent_id: agent_id,
        name: name,
        agentList: agentList,
        getActivePartnersResult: getActivePartnersResult,
        agentStatus: status,
        accountsCount: accountsCount,
      },
    });
  };

  const checkLoading = () => {
    if (
      viewAgentStatus === STATUS.LOADING ||
      editAgentStatus === STATUS.LOADING ||
      activateAgentStatus === STATUS.LOADING ||
      deactivateAgentStatus === STATUS.LOADING ||
      approveAgentStatus === STATUS.LOADING
    ) {
      return true;
    } else {
      return false;
    }
  };

  const rows = [
    CreateItems("Name", name),
    CreateItems("Ownership", ownership),
    CreateItems(
      "Status",
      { 1: "Active", 2: "Inactive", 3: "Pending", 4: "Rejected" }[status],
    ),
    CreateItems("Region", region),
    CreateItems("District", district),
    CreateItems("Ward", ward),
    CreateItems("Street", street),
    CreateItems("Post Code", post_code),
    CreateItems("Zip Code", zip_code),
    CreateItems("Nearest landmark", nearest),
    CreateItems("Other Details", other),
    CreateItems("Remark", remark),
    CreateItems("Account Code", accountCode.toString()),
    CreateItems("Bank Account Number", bankNumber),
  ];

  return (
    <Box>
      <PageTitle title={`Agent ${name} Details`} />

      <LoadingView loading={checkLoading()} />

      {/* Contents */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
        {/* Action Button */}
        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          {/* ----- Only manager can approve, reject, activate and deactivate agent ----- */}
          {status != 4 &&
            loginResult.role === 2 &&
            (status === 3 ? (
              <>
                <Button
                  color="success"
                  startDecorator={<TaskAltOutlined />}
                  onClick={approveAgent}
                >
                  Approve
                </Button>
                <Button
                  color="warning"
                  startDecorator={<BlockOutlined />}
                  onClick={() => setRejectModal(true)}
                >
                  Reject
                </Button>
              </>
            ) : status === 1 ? (
              <>
                <Button
                  color="danger"
                  startDecorator={<DoNotDisturbOn />}
                  onClick={() => setDeactivateModal(true)}
                >
                  Deactivate
                </Button>
              </>
            ) : (
              <Button
                color="success"
                startDecorator={<CheckCircle />}
                onClick={activateAgent}
              >
                Activate
              </Button>
            ))}

          {/* only sale officer can edit */}
          {status === 1 && loginResult.role === 3 && (
            <Button
              color="primary"
              startDecorator={<EditOutlined />}
              onClick={() => setFormModal(true)}
            >
              Edit
            </Button>
          )}

          {/* view agent users */}
          <Button
            color="neutral"
            startDecorator={<RemoveRedEyeOutlined />}
            onClick={goToAgent}
          >
            View Agent User
          </Button>

          {/* view agent accounts */}
          <Button
            color="neutral"
            // startDecorator={<RemoveRedEyeOutlined />}
            onClick={goToViewPage}
          >
            View Account
          </Button>

          {/* view agent accounts */}
          <Button color="primary" onClick={goToAgentBankDetails}>
            View Bank Details
          </Button>

          {/* view agent commissions */}
          <Button color="primary" onClick={goToCommissions}>
            View Commissions
          </Button>
        </Box>

        {/* Details */}
        <Box
          sx={{
            gap: 2,
            display: "flex",
            flexDirection: "column",
            width: { xs: "unset", md: "70%" },
          }}
        >
          {/* client details */}
          <Sheet
            className="OrderTableContainer"
            variant="outlined"
            sx={{
              // display: 'flex',
              // width: '100%',
              borderRadius: "sm",
              flexShrink: 1,
              overflow: "auto",
              minHeight: 0,
            }}
          >
            <Table
              // aria-label="striped table"
              // stripe="odd"
              // variant="soft"
              aria-labelledby="tableTitle"
              stickyHeader
              hoverRow
              sx={{
                "--TableCell-headBackground":
                  "var(--joy-palette-background-level2)",
                "--Table-headerUnderlineThickness": "1px",
                "--TableRow-hoverBackground":
                  "var(--joy-palette-background-level1)",
                "--TableCell-paddingY": "4px",
                "--TableCell-paddingX": "8px",
              }}
            >
              <thead>
                <tr>
                  <th style={{ width: "40%", fontSize: 18 }}>Agent Details</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr key={index}>
                    <td>
                      <b>{row.title}</b>
                    </td>
                    <td>{row.value}</td>
                  </tr>
                ))}
                <tr>
                  {/* <td><b>Map Location</b></td> */}
                  <td>
                    <AspectRatio
                      variant="outlined"
                      ratio="1"
                      sx={{ width: "150", borderRadius: 4 }}
                    >
                      <MapContainer
                        latitude={location.latitude}
                        longitude={location.longitude}
                      />
                    </AspectRatio>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Sheet>

          {/* Attachments */}
          <Sheet
            className="OrderTableContainer"
            variant="outlined"
            sx={{
              // display: 'flex',
              // width: '100%',
              borderRadius: "sm",
              flexShrink: 1,
              overflow: "auto",
              minHeight: 0,
            }}
          >
            <Table
              // aria-label="striped table"
              // stripe="odd"
              // variant="soft"
              aria-labelledby="tableTitle"
              stickyHeader
              hoverRow
              sx={{
                "--TableCell-headBackground":
                  "var(--joy-palette-background-level2)",
                "--Table-headerUnderlineThickness": "1px",
                "--TableRow-hoverBackground":
                  "var(--joy-palette-background-level1)",
                "--TableCell-paddingY": "4px",
                "--TableCell-paddingX": "8px",
              }}
            >
              <thead>
                <tr>
                  <th style={{ width: "40%", fontSize: 18 }}>Attachments</th>
                  <th></th>
                </tr>
              </thead>
              {attachments.map((item, index) => (
                <tbody key={index}>
                  <tr>
                    <td>
                      <b>Attachment Name</b>
                    </td>
                    <td>{item.attachment_name}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>Attachment Value</b>
                    </td>
                    <td>Tsh. {item.attachment_value}</td>
                  </tr>
                  <tr>
                    {/* <td>
                                    <Typography><b>Attachment File</b></Typography>

                                </td> */}
                    <td>
                      <AspectRatio
                        variant="outlined"
                        ratio="1"
                        sx={{ width: "150", borderRadius: 4 }}
                      >
                        <img src={item.url} loading="lazy" alt="" />
                      </AspectRatio>
                    </td>
                  </tr>
                  <tr style={{ height: "15px" }}></tr>
                </tbody>
              ))}
            </Table>
          </Sheet>
        </Box>
      </Box>

      {/* ------ Modal form for add and edit Agent details ------ */}
      <Modal open={formModal}>
        <ModalOverflow sx={{ pt: "70px" }}>
          <ModalDialog
            aria-labelledby="nested-modal-title"
            aria-describedby="nested-modal-description"
            // aria-labelledby="modal-dialog-overflow"
            // layout="fullscreen"
            sx={(theme) => ({
              // pt: '600px',
              minWidth: { xs: "unset", md: "800px" },
              [theme.breakpoints.only("xs")]: {
                top: "60px",
                bottom: 0,
                left: 0,
                right: 0,
                // borderRadius: 0,
                borderTopLeftRadius: 20,
                borderTopRightRadius: 20,
                transform: "none",
                maxWidth: "unset",
                overflow: "auto",
              },
            })}
          >
            <ModalClose
              variant="outlined"
              onClick={() => setFormModal(false)}
            />
            <DialogTitle>{`Edit ${name} Details`}</DialogTitle>
            <DialogContent>Please enter Agent details correct.</DialogContent>
            <Stack
              component="form"
              onSubmit={submitForm}
              gap={2}
              sx={{ mt: 2 }}
            >
              <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                {/* name */}
                <FormControl sx={{ flex: 1 }} required>
                  <FormLabel>Agent Name</FormLabel>
                  <Input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Enter agent name"
                  />
                </FormControl>

                {/* ownership */}
                <FormControl sx={{ flex: 1 }} required>
                  <FormLabel>Agent Ownership</FormLabel>
                  <Select
                    placeholder="Select agent ownership"
                    value={ownership}
                    onChange={handleAgentAdd}
                    required
                  >
                    <Option value="Group">Group</Option>
                    <Option value="Individual">Individual</Option>
                    <Option value="Company">Company</Option>
                  </Select>
                </FormControl>
              </Stack>

              <Typography level="title-md">Address</Typography>
              <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                {/* region */}
                <FormControl sx={{ flex: 1 }} required>
                  <FormLabel>Region</FormLabel>
                  <Select
                    placeholder="Select region"
                    value={region}
                    onChange={handleRegion}
                    required
                  >
                    {regionList.map((dt) => (
                      <Option value={dt}>{dt}</Option>
                    ))}
                  </Select>
                </FormControl>

                {/* district */}
                {region && (
                  <FormControl sx={{ flex: 1 }} required>
                    <FormLabel>District</FormLabel>
                    <Select
                      placeholder="Select district"
                      value={district}
                      onChange={handleDistrict}
                      required
                    >
                      {districtList.map((dt) => (
                        <Option value={dt}>{dt}</Option>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Stack>

              <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                {/* Ward */}
                <FormControl sx={{ flex: 1 }} required>
                  <FormLabel>Ward</FormLabel>
                  <Input
                    type="text"
                    value={ward}
                    onChange={(e) => setWard(e.target.value)}
                    placeholder="Enter ward"
                  />
                </FormControl>

                {/* street */}
                <FormControl sx={{ flex: 1 }} required>
                  <FormLabel>Street</FormLabel>
                  <Input
                    type="text"
                    value={street}
                    onChange={(e) => setStreet(e.target.value)}
                    placeholder="Enter street"
                  />
                </FormControl>
              </Stack>

              <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                {/* post code */}
                <FormControl required sx={{ flex: 1 }}>
                  <FormLabel>Post code</FormLabel>
                  <Input
                    type="text"
                    value={post_code}
                    onChange={(e) => setPostCode(e.target.value)}
                    placeholder="Enter post code"
                  />
                </FormControl>

                {/* zip code */}
                <FormControl required sx={{ flex: 1 }}>
                  <FormLabel>Zip Code</FormLabel>
                  <Input
                    type="text"
                    value={zip_code}
                    onChange={(e) => setZipCode(e.target.value)}
                    placeholder="Enter zip code"
                  />
                </FormControl>

                {/* nearest land mark */}
                <FormControl required sx={{ flex: 1 }}>
                  <FormLabel>Nearest land mark</FormLabel>
                  <Input
                    type="text"
                    value={nearest}
                    onChange={(e) => setNearest(e.target.value)}
                    placeholder="Enter nearest landmark"
                  />
                </FormControl>
              </Stack>

              <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                {/* map */}
                {location.latitude != 0 && (
                  <Box>
                    <Typography level="title-sm">
                      * Point your location on map
                    </Typography>
                    <AspectRatio
                      variant="outlined"
                      ratio="1"
                      sx={{ width: 300, borderRadius: 4 }}
                    >
                      <MapContainer
                        latitude={location.latitude}
                        longitude={location.longitude}
                        setLocation={setLocation}
                      />
                    </AspectRatio>
                  </Box>
                )}
                {/* location coordinates */}
                <FormControl sx={{ flex: 1 }}>
                  <FormLabel>Location</FormLabel>
                  <Input
                    readOnly
                    placeholder={
                      location.latitude == 0
                        ? "<--- Click to open map"
                        : `lat: ${location.latitude} long: ${location.longitude}`
                    }
                    // value={location.latitude}
                    startDecorator={
                      <Button
                        variant="soft"
                        color="neutral"
                        startDecorator={<LocationOn />}
                        onClick={getLocation}
                      >
                        {location.latitude === 0
                          ? "Open map"
                          : "Current location"}
                      </Button>
                    }
                  />
                </FormControl>
              </Stack>

              {/* attachments */}
              <Typography level="title-md">Attachments</Typography>
              {attachments.map((field, index) => (
                <Box
                  key={index}
                  sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                >
                  <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                    <FormControl sx={{ flex: 1 }} required>
                      <FormLabel>Attachment Name</FormLabel>
                      <Input
                        type="text"
                        value={field.attachment_name}
                        onChange={(event) =>
                          handleAttachmentsChange(
                            index,
                            "attachment_name",
                            event.target.value,
                          )
                        }
                        placeholder="Enter attachment name"
                        required
                      />
                    </FormControl>
                    <FormControl sx={{ flex: 1 }} required>
                      <FormLabel>Value</FormLabel>
                      <Input
                        type="text"
                        value={field.attachment_value}
                        onChange={(event) =>
                          handleAttachmentsChange(
                            index,
                            "attachment_value",
                            event.target.value,
                          )
                        }
                        // slotProps={{input: {component: NumericFormatAdapter}}}
                        // startDecorator={"Tsh."}
                        required
                      />
                    </FormControl>
                  </Stack>

                  <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                    <FormControl sx={{ flex: 1 }}>
                      <FormLabel>Attachment file</FormLabel>
                      <input
                        type="file"
                        id={`col-picture${index}`}
                        hidden
                        onChange={(event) => handlePicture(event, index)}
                      />

                      <Input
                        type="file"
                        startDecorator={
                          <Button
                            variant="soft"
                            color="neutral"
                            startDecorator={<FolderOpenOutlined />}
                          >
                            <label htmlFor={`col-picture${index}`}>
                              Choose File
                            </label>
                          </Button>
                        }
                        sx={{
                          // Define internal styles for the file input
                          '& input[type="file"]::file-selector-button': {
                            display: "none",
                          },
                        }}
                        onChange={(event) => handlePicture(event, index)}
                      />
                    </FormControl>

                    {field.url != "" && (
                      <AspectRatio
                        variant="outlined"
                        ratio="1"
                        sx={{ width: 150, borderRadius: 4 }}
                      >
                        <img src={field.url} loading="lazy" alt="" />
                      </AspectRatio>
                    )}
                  </Stack>

                  <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                    <ButtonGroup sx={{ mt: 1 }}>
                      {field.url != null && (
                        <Button
                          onClick={addAttachmentsData}
                          variant="solid"
                          color="primary"
                        >
                          + Add
                        </Button>
                      )}
                      {attachments.length > 1 && (
                        <Button
                          onClick={() => removeAttachmentsData(index)}
                          variant="solid"
                          color="danger"
                        >
                          - Remove
                        </Button>
                      )}
                    </ButtonGroup>

                    <Divider sx={{ my: 2 }} />
                  </Stack>
                </Box>
              ))}

              {/* other info */}
              <FormControl sx={{ flex: 1 }}>
                <FormLabel>Other Details</FormLabel>
                <Input
                  type="text"
                  value={other}
                  onChange={(e) => setOther(e.target.value)}
                  placeholder="Enter other details if available"
                />
              </FormControl>

              <Stack gap={4} sx={{ mt: 2 }}>
                <Button type="submit" fullWidth>
                  Submit
                </Button>
              </Stack>
            </Stack>
          </ModalDialog>
        </ModalOverflow>
      </Modal>

      {/* reject modal */}
      <Modal open={rejectModal}>
        <ModalDialog
          aria-labelledby="nested-modal-title"
          aria-describedby="nested-modal-description"
          // aria-labelledby="modal-dialog-overflow"
          // layout="fullscreen"
          sx={(theme) => ({
            [theme.breakpoints.only("xs")]: {
              bottom: 0,
              left: 0,
              right: 0,
              // borderRadius: 0,
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              transform: "none",
              maxWidth: "unset",
              overflow: "auto",
            },
          })}
        >
          <ModalClose
            variant="outlined"
            onClick={() => setRejectModal(false)}
          />
          <DialogTitle>{"Reject staff:" + name}</DialogTitle>
          <DialogContent>Please write a reason for rejection.</DialogContent>
          <Stack
            component={"form"}
            onSubmit={rejectAgent}
            gap={2}
            sx={{ mt: 2 }}
          >
            {/* rejection reason */}
            <FormControl sx={{ flex: 1 }} required>
              <FormLabel>Rejection reason</FormLabel>
              <Input
                type="text"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                placeholder="Enter rejection reason"
              />
            </FormControl>

            <Button type="submit" fullWidth>
              REJECT
            </Button>
          </Stack>
        </ModalDialog>
      </Modal>

      {/* deactivate modal */}
      <Modal open={deactivateModal}>
        <ModalDialog
          aria-labelledby="nested-modal-title"
          aria-describedby="nested-modal-description"
          // aria-labelledby="modal-dialog-overflow"
          // layout="fullscreen"
          sx={(theme) => ({
            [theme.breakpoints.only("xs")]: {
              bottom: 0,
              left: 0,
              right: 0,
              // borderRadius: 0,
              borderTopLeftRadius: 20,
              borderTopRightRadius: 20,
              transform: "none",
              maxWidth: "unset",
              overflow: "auto",
            },
          })}
        >
          <ModalClose
            variant="outlined"
            onClick={() => setDeactivateModal(false)}
          />
          <DialogTitle>{"Deactivate agent:" + name}</DialogTitle>
          <DialogContent>Please write a reason for deactivation.</DialogContent>
          <Stack
            component={"form"}
            onSubmit={deactivateAgent}
            gap={2}
            sx={{ mt: 2 }}
          >
            {/* rejection reason */}
            <FormControl sx={{ flex: 1 }} required>
              <FormLabel>Deactivate reason</FormLabel>
              <Input
                type="text"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                placeholder="Enter rejection reason"
              />
            </FormControl>

            <Button type="submit" fullWidth>
              DEACTIVATE
            </Button>
          </Stack>
        </ModalDialog>
      </Modal>
    </Box>
  );
};

const mapStateToProps = ({ accounts, agent, agentStaff, auth, partner }) => {
  const { otpResult: loginResult } = auth;
  const {
    agentStaffListResult,
    agentStaffListStatus,
    agentStaffListErrorMessage,
  } = agentStaff;
  const {
    editAgentStatus,
    editAgentResult,
    editAgentErrorMessage,

    viewAgentStatus,
    viewAgentResult,
    viewAgentErrorMessage,

    rejectAgentStatus,
    rejectAgentResult,
    rejectAgentErrorMessage,

    approveAgentStatus,
    approveAgentResult,
    approveAgentErrorMessage,

    activateAgentStatus,
    activateAgentResult,
    activateAgentErrorMessage,

    deactivateAgentStatus,
    deactivateAgentResult,
    deactivateAgentErrorMessage,
  } = agent;

  const {
    getActivePartnersStatus,
    getActivePartnersResult,
    getActivePartnersErrorMessage,
  } = partner;

  const {
    getWakalaAccountDetailsStatus,
    getWakalaAccountDetailsResult,
    getWakalaAccountDetailsErrorMessage,
  } = accounts;

  return {
    loginResult,

    editAgentStatus,
    editAgentResult,
    editAgentErrorMessage,

    viewAgentStatus,
    viewAgentResult,
    viewAgentErrorMessage,

    rejectAgentStatus,
    rejectAgentResult,
    rejectAgentErrorMessage,

    approveAgentStatus,
    approveAgentResult,
    approveAgentErrorMessage,

    activateAgentStatus,
    activateAgentResult,
    activateAgentErrorMessage,

    deactivateAgentStatus,
    deactivateAgentResult,
    deactivateAgentErrorMessage,

    agentStaffListStatus,
    agentStaffListResult,
    agentStaffListErrorMessage,

    getActivePartnersStatus,
    getActivePartnersResult,
    getActivePartnersErrorMessage,

    getWakalaAccountDetailsStatus,
    getWakalaAccountDetailsResult,
    getWakalaAccountDetailsErrorMessage,
  };
};

export default connect(mapStateToProps, {})(AgentViewPage);
